export const Spinner = ({ full = false, label = "Loading" }) => (
  <div
    data-testid="loading-spinner"
    role="status"
    aria-label={label}
    className={`flex items-center justify-center ${full ? "min-h-screen" : "py-16"}`}
  >
    <span className="h-9 w-9 animate-spin rounded-full border-[3px] border-slate-200 border-t-[#064E3B] motion-reduce:animate-none" />
  </div>
);
